import React from "react";
import { Route, Routes } from "react-router-dom";
import { FlightProvider } from '@src/features/order/provider';
import { FlightDroneProvider } from "./provider/flight-drone-provider";
import { DronesPage } from "./pages/drones-page";

const DroneFeature: React.FC = () => {
  return (
    <FlightProvider>  
      <FlightDroneProvider>
        <Routes>
          <Route index element={<DronesPage />}/>
        </Routes>
      </FlightDroneProvider>
    </FlightProvider>
  );
};

export default DroneFeature;    
